import styled from 'styled-components'

const itemHeight = 30

const buttonScale = 0.85
const buttonWidth = 295
const buttonHeight = 45

export const Label = styled.div`
  position: relative;
  width: 100%;
  height: ${itemHeight}px;
  margin-top: 10px;
  margin-left: 0.5em;

  display: flex;
  width: 100%;
  height: ${props => props.selected ? itemHeight * 1.1 : itemHeight}px;
  justify-content: ${props => props.center ? 'center' : 'left'};
  align-items: center;

  font-family: 'Barthowheel-Regular';
  text-align: left;
  font-size: 1em;
  color: #FFF;
  background: transparent;
  z-index: 2;
  
  transition: 0.3s;

  @media screen and (max-width: 812px) {
    height: ${props => props.selected ? itemHeight * 1.5 : itemHeight * 1.4}px;
  }
`
export const ButtonBackground = styled.div`
  position: absolute;
  width: ${buttonWidth * buttonScale}px;
  height: ${buttonHeight}px;
  top: 0;
  left: 0;

  color: #e6f2fe;
  background: rgba(5, 75, 130, 1);
  z-index: 1;
  clip-path: polygon(2% 0, 100% 12%, 99% 87%, 0 97%);
  transform: scaleX(0.85);

  @media screen and (max-width: 812px) {
    height: 35px;
    transform-origin: 0;
  }
`

export const Button = styled.button`
  position: relative;
  top: ${ props => props.selected ? '-5px' : '0' };
  left: ${ props => props.selected ? '5px' : '0' };
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  width: ${buttonWidth * buttonScale}px;
  height: ${buttonHeight}px;

  border: 0;
  padding: 0;

  font-family: 'Crash';
  font-size: 1.65em;
  transform: scaleX(0.85);
  color: #60b2e1;
  background: transparent;
  z-index: ${ props => props.selected ? 3 : 1 };
  clip-path: ${ props => props.selected ? 'polygon(2% 0, 100% 12%, 99% 82%, 0 100%)' : 'polygon(2% 0, 100% 12%, 99% 87%, 0 97%)' };
  transition: 0.1s;

  @media screen and (max-width: 812px) {
    height: 35px;
    font-size: 1.35em;
    transform-origin: 0;
  }

  &:hover{
    top: -3px;
    left: 3px;
    color: #054b82;
    background: rgba(219, 239, 245, 1);
    /* clip-path: polygon(2% 0, 100% 12%, 99% 82%, 0 100%); */
    z-index: 3;
    transition: 0.1s;
  }

  &:active{
    top: 0px;
    left: 0px;
    color: #054b82;
    background: rgba(219, 239, 245, 1);
    /* clip-path: polygon(2% 0, 100% 12%, 99% 82%, 0 100%); */
    z-index: 3;
    transition: 0.1s;
  }
`